import { CmsApplianceDetailsSteppedBenefitsPanel } from '../../models/appliance-details-stepped-benefits-panel/cms-appliance-details-stepped-benefits-panel.interface';

export const mockCmsApplianceDetailsSteppedBenefitsPanel: CmsApplianceDetailsSteppedBenefitsPanel =
  {
    benefits: {
      item0: {
        body: 'Benefit 1',
        icon: {
          name: 'shield-check',
        },
      },
      item1: {
        body: 'Benefit 2',
        icon: {
          name: 'dog',
        },
      },
      item2: {
        body: '<strong>Benefit 3</strong>',
        icon: {
          name: 'horse',
        },
      },
    },
    title: 'Why choose Domestic & General?',
    additionalBenefit: 'Additional Benefit',
  };
